
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.md?watch=parent';
    export const toc = [{"id":"定制模型输出-ui","depth":2,"title":"定制模型输出 UI"}];
export const frontmatter = {"title":"定制模型输出 UI","toc":"content","filename":"docs/guide/custom-ui.md","lastUpdated":1769581795000,"nav":{"title":"指南","order":0},"order":1,"description":"为模型输出的结构化数据，通过代码块的方式定制 UI。"};